import { __ } from '@wordpress/i18n/'
import { useContext, useRef } from 'react';
import SbUtils from '../../../../Utils/SbUtils';
import Button from "../../../Common/Button";
import SettingsScreenContext from '../../../Context/SettingsScreenContext';

const ManageImportFeed = ( props ) => {

    const {
        sbCustomizer,
        editorNotification,
        editorTopLoader
    } = useContext( SettingsScreenContext) ;

    const importFeedRef = useRef();

    const notificationsContent = {
        success: {}
    },

    successNotification = {
        type : 'success',
        icon : 'success',
        text : __( 'Feed Imported', 'sb-customizer' )
    },
    errorNotification = {
        type : 'error',
        icon : 'notice',
        text : __( 'Feed Import Failed', 'sb-customizer' ),
        time: 60000
    };

    const importFeed = ( event ) => {
        const feedFile = event.target.files[0];
        if ( feedFile ) {
            const formData = {
                action : 'sbtt_import_feed_settings',
                feedFile : feedFile
            }
            SbUtils.ajaxPost(
                sbCustomizer.ajaxHandler,
                formData,
                ( data ) => { //Call Back Function
                    if( data?.success ){
                        notificationsContent.success = successNotification;
                    } else {
                        notificationsContent.success = errorNotification;
                    }
                },
                editorTopLoader,
                editorNotification,
                notificationsContent
            )
        }
    }


    return (
        <>
        <div className='sb-settings-input-ctn'>
            <input
                className='sb-import-input'
                type='file'
                accept='.json,application/json'
                ref={ importFeedRef }
                onChange={ ( event ) => {
                    importFeed( event )
                }}
            />
            <Button
                text={  __( 'Import', 'sb-customizer' ) }
                type='secondary'
                size='medium'
                icon='import'
                iconSize='11'
                onClick={ () => {
                    if ( importFeedRef.current ) {
                        importFeedRef.current.click();
                    }
                } }
            />
        </div>
        </>
    )
}

export default ManageImportFeed;